<div class="mat-container mt-2">
  <table mat-table #table [dataSource]="dataSource">
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>Category</th>
      <td mat-cell *matCellDef="let element" class="white-back">
        <span class="d-flex align-items-center bold blue">
          {{ element.name }}
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="privileges">
      <th mat-header-cell *matHeaderCellDef>Privileges</th>
      <td
        mat-cell
        *matCellDef="let element"
        [ngClass]="showChanges ? element.pendingClass : ''"
      >
        <div class="d-flex">
          <mat-chip-set class="example-chip">
            <mat-chip
              class="d-flex align-items-center"
              *ngFor="let rp of element.rolePrivileges"
              ngClass="{{ rp.pending ? rp.pendingClass : 'chip' }}"
            >
              <mat-icon
                class="white indicator"
                *ngIf="rp.pendingClass == 'yellow-bg'"
                >add_box</mat-icon
              >
              <mat-icon
                class="white indicator"
                *ngIf="rp.pendingClass == 'red-bg'"
                >cancel</mat-icon
              >
              {{ rp.privilegeObj.name }}
            </mat-chip>
          </mat-chip-set>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>
        <mat-icon
          mat-list-icon
          *ngIf="
            role?.status !== 0 &&
            modifying &&
            hasPrivilege(privilegeEnum.RoleCatalogPrivileges)
          "
          class="add fakeA"
          color="primary"
          (click)="openRolePrivilegeDialog()"
          >add_box</mat-icon
        >
        <mat-icon
          mat-list-icon
          *ngIf="
            role?.status === 0 &&
            hasPrivilege(privilegeEnum.RoleCatalogPrivileges)
          "
          class="add fakeA colorDisabled"
          matTooltip="You can not add privileges to an inactive role"
          >edit</mat-icon
        >
      </th>
      <td mat-cell *matCellDef="let element">
        <button
          mat-icon-button
          *ngIf="
            role?.status !== 0 &&
            modifying &&
            hasPrivilege(privilegeEnum.RoleCatalogPrivileges)
          "
          color="primary"
          (click)="openRolePrivilegeDialog(element.id)"
        >
          <mat-icon class="add fakeA">edit</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
